import * as React from "react";
const CancelIcon = (props) => (
  <svg
    width={19}
    height={19}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.83292 0.46633L9.5 7.13312L16.1325 0.500873C16.279 0.344942 16.4555 0.220202 16.6514 0.134134C16.8473 0.0480663 17.0585 0.00244278 17.2725 0C17.7306 0 18.1699 0.181967 18.4938 0.50587C18.8177 0.829773 18.9997 1.26908 18.9997 1.72715C19.0037 1.9389 18.9645 2.14924 18.8843 2.34526C18.8041 2.54129 18.6847 2.71885 18.5334 2.86707L11.8145 9.49932L18.5334 16.2179C18.818 16.4964 18.985 16.8735 18.9997 17.2715C18.9997 17.7296 18.8177 18.1689 18.4938 18.4928C18.1699 18.8167 17.7306 18.9986 17.2725 18.9986C17.0524 19.0078 16.8328 18.971 16.6276 18.8907C16.4224 18.8105 16.2362 18.6884 16.0807 18.5323L9.5 11.8655L2.8502 18.515C2.70426 18.6658 2.52991 18.7861 2.33722 18.8691C2.14452 18.9521 1.9373 18.9961 1.7275 18.9986C1.26942 18.9986 0.830089 18.8167 0.506172 18.4928C0.182256 18.1689 0.00028103 17.7296 0.00028103 17.2715C-0.00374598 17.0597 0.035543 16.8494 0.115737 16.6534C0.195931 16.4573 0.315339 16.2798 0.466631 16.1316L7.18552 9.49932L0.466631 2.78071C0.181959 2.50222 0.0150308 2.1251 0.00028103 1.72715C0.00028103 1.26908 0.182256 0.829773 0.506172 0.50587C0.830089 0.181967 1.26942 0 1.7275 0C2.14204 0.00518145 2.5393 0.172715 2.83292 0.46633Z"
      fill="black"
    />
  </svg>
);
export default CancelIcon;
